import { Box } from '@mui/material'
import { tokens } from 'ComponentLibrary'

type SimpleTableCellProps = {
    alignment?: 'left' | 'right'
    children?: React.ReactNode
    dynamicHeight?: boolean
    highlight?: boolean
    selected?: boolean
    hoverable?: boolean
}

export function SimpleTableCell({ alignment, children, dynamicHeight, highlight, selected, hoverable }: SimpleTableCellProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
                paddingLeft: tokens.SizingSpacing100,
                paddingRight: tokens.SizingSpacing100,
                justifyContent: alignment === 'right' ? 'flex-end' : 'flex-start',
                alignItems: 'center',
                whiteSpace: 'nowrap',
                flexShrink: 0,
                borderBottom: `${tokens.SizingBorderS} solid ${highlight ? tokens.ColorBorderWarning : tokens.ColorBorderDefault}`,
                minHeight: '32px',
                height: dynamicHeight ? 'auto' : '32px',
                paddingTop: dynamicHeight ? tokens.SizingSpacing050 : undefined,
                paddingBottom: dynamicHeight ? tokens.SizingSpacing050 : undefined,
                boxSizing: 'border-box',
                bgcolor: highlight ? tokens.ColorSurfaceWarningDefault : undefined,
                ...(hoverable
                    ? {
                          'tr:hover &': highlight
                              ? { bgcolor: selected ? '#f0f2e4' : '#f0e8dd' }
                              : { bgcolor: selected ? undefined : tokens.ColorSurfaceHover },
                      }
                    : {}),
            }}
        >
            {children}
        </Box>
    )
}

export function SimpleTableEmptyFooter() {
    return (
        <Box
            sx={{
                width: '100%',
                paddingLeft: tokens.SizingSpacing100,
                paddingRight: tokens.SizingSpacing100,
                height: tokens.SizingSpacing300,
            }}
        />
    )
}
